import { Link } from "react-router-dom";
import { PlayCircle } from "lucide-react";

// API-relative media paths (/api/ott/...) need the backend origin; external thumbnails are absolute.
export const mediaUrl = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

const dur = (s) => (s ? `${Math.floor(s / 60)}:${String(Math.round(s % 60)).padStart(2, "0")}` : "");

export const VideoCard = ({ v, progress }) => (
  <Link to={`/ott/watch/${v.video_id}`} className="group rounded-2xl bg-white border border-stone-200 overflow-hidden hover:shadow-md transition-shadow" data-testid={`ott-card-${v.video_id}`}>
    <div className="aspect-video bg-stone-900 relative grid place-items-center">
      {v.thumb_url ? <img src={mediaUrl(v.thumb_url)} alt="" loading="lazy" className="w-full h-full object-cover" />
        : <PlayCircle className="text-white/60" size={32} />}
      {v.duration_s ? <span className="absolute bottom-1 right-1 text-[10px] font-bold bg-black/70 text-white rounded px-1">{dur(v.duration_s)}</span> : null}
      {v.kind === "link" && <span className="absolute top-1 left-1 text-[9px] font-black uppercase bg-white/90 rounded px-1">{v.external?.provider}</span>}
      {progress > 0 && v.duration_s ? <div className="absolute bottom-0 left-0 h-1 bg-red-600" style={{ width: `${Math.min(100, (progress / v.duration_s) * 100)}%` }} /> : null}
    </div>
    <div className="p-2">
      <div className="text-sm font-black text-stone-900 line-clamp-2">{v.title}</div>
      <div className="text-[11px] text-stone-500">{v.creator_name} · {v.views || 0} views</div>
    </div>
  </Link>
);
